import { storeLanguages } from "constants/languages";

const defaultState = {
  sidebarLocked: false,
  insightsMode: "channel", // ["channel", "domain"]
  options: {
    campaignFilterPersonal: "company", // ["company", "creator"]
  },
  plansInProgress: [], // Plans (scheme) that are waiting the content to be inserted with cron-job
  unreadMessages: 0,
  unreadNotifications: 0,
  user: {
    id: null,
    username: null,
    firstName: "",
    lastName: "",
    email: null,
    image: null,
  },
  companies: [],
  storeLang: storeLanguages[0], // Language of store categories (this is separate from coach system language)
  storeProductsLanguageFilter: "all",
  selectedChannel: {},

  auth: {
    logged: false,
    accessToken: null,
    refreshToken: null,
    expireTime: null,
    tokenType: null,
  },
  brpLocation: {
    id: null,
    name: null,
    slug: null,
  },
};

const resolveNextStoreLanguage = (current) => {
  const currentIndex = storeLanguages.indexOf(current);
  if (currentIndex === -1) {
    return storeLanguages[0];
  }

  const nextIndex = (currentIndex + 1) % storeLanguages.length;
  return storeLanguages[nextIndex];
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case "SIDEBAR_TOGGLE":
      return {
        ...state,
        sidebarLocked: action.payload,
      };
    case "LOGIN":
      return {
        ...state,
        auth: action.payload,
      };

    case "LOGOUT":
      return {
        ...defaultState,
        // Need to reset everything here when logging out
        brpLocation: {
          id: null,
          name: null,
          slug: null,
        },
      };
    case "SET_BRP_LOCATION":
      return {
        ...state,
        brpLocation: {
          ...state.brpLocation,
          ...action.payload,
        },
      };
    case "SET_COMPANIES":
      return {
        ...state,
        companies: action.payload.list,
        selectedChannel: action.payload.selected,
      };
    case "SELECT_CHANNEL":
      return {
        ...state,
        selectedChannel: action.payload || {},
        insightsMode: "channel",
      };
    case "SET_USER":
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload,
        },
      };
    case "SET_INSIGHTS":
      return {
        ...state,
        insightsMode: action.payload,
      };
    case "SET_UNREAD_NOTIFICATIONS":
      return {
        ...state,
        unreadNotifications: action.payload,
      };
    case "SET_UNREAD_MESSAGES":
      return {
        ...state,
        unreadMessages: action.payload,
      };
    case "SET_CAMPAIGN_FILTER_PERSONAL":
      return {
        ...state,
        options: {
          ...state.options,
          campaignFilterPersonal: action.payload,
        },
      };
    case "SET_UNREADS":
      return {
        ...state,
        unreadMessages: action.payload.unreadMessages,
        unreadNotifications: action.payload.unreadNotifications,
      };
    case "SET_WAITING_PLAN":
      return {
        ...state,
        plansInProgress: [...state.plansInProgress, action.payload],
      };
    case "DELETE_WAITING_PLAN":
      return {
        ...state,
        plansInProgress: state.plansInProgress.filter(
          (p) => p != action.payload
        ),
      };
    case "STORE_LANG_TOGGLE": {
      const nextStoreLang =
        action.payload && storeLanguages.includes(action.payload)
          ? action.payload
          : resolveNextStoreLanguage(state.storeLang);

      return {
        ...state,
        storeLang: nextStoreLang,
      };
    }
    case "STORE_LANG_SET":
      return {
        ...state,
        storeLang: action.payload,
      };
    case "STORE_PRODUCTS_LANGUAGE_FILTER_SET":
      return {
        ...state,
        storeProductsLanguageFilter: action.payload,
      };
    default:
      return state;
  }
}
